// Обезличенные предложения публичного демо, организация 41, снимок 04.11.2026.
// Цены и единицы сохранены из прайсов, источник описан в docs/product/demo-iiko.md.
export const inventoryDemoCatalog: ReadonlyArray<InventoryDemoCatalogOffer> = [
  {
    id: 14193,
    name: 'Куриное филе грудки б/кожи сух. зам.',
    price: 487.27,
    unit: 'кг',
    packageSize: '~10кг',
    productTypeId: 17,
    supplierId: 11,
    supplierName: 'ООО «Белая Кухня»',
  },
  {
    id: 14194,
    name: 'Куриное филе грудки б/кожи /блок (ЕКБ)',
    price: 430.49,
    unit: 'кг',
    packageSize: '~13кг',
    productTypeId: 17,
    supplierId: 11,
    supplierName: 'ООО «Белая Кухня»',
  },
  {
    id: 15748,
    name: 'Фарш говяжий F зам в/у',
    price: 658.53,
    unit: 'кг',
    packageSize: '~3,6 кг',
    productTypeId: 5,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
  {
    id: 15749,
    name: 'Фарш говяжий зам в/у',
    price: 695.84,
    unit: 'кг',
    packageSize: '~3,6 кг',
    productTypeId: 5,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
  {
    id: 16442,
    name: 'Картофель фри 7 х 7 (A) Feast . ( х 5 шт)',
    price: 192.97,
    unit: 'кг',
    packageSize: '12,5 кг/кор',
    productTypeId: 218,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
  {
    id: 16430,
    name: 'Картофель фри 10 х 10 Байсад',
    price: 311.44,
    unit: 'шт',
    packageSize: '2,5 кг',
    productTypeId: 218,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
  {
    id: 14954,
    name: 'Макароны Лингвини из тверд.сорт.пш ет Бронза Divella',
    price: 168.67,
    unit: 'шт',
    packageSize: '24х500гр',
    productTypeId: 121,
    supplierId: 11,
    supplierName: 'ООО «Белая Кухня»',
  },
  {
    id: 14891,
    name: 'Сливки 22% tetra-pak с крышкой для соуса Эlakto ГОСТ БЗМЖ UHT',
    price: 283.91,
    unit: 'шт',
    packageSize: '12х1л',
    productTypeId: 75,
    supplierId: 11,
    supplierName: 'ООО «Белая Кухня»',
  },
  {
    id: 13715,
    name: 'Сыр Моцарелла Extra /50%',
    price: 502.47,
    unit: 'кг',
    packageSize: '2кг',
    productTypeId: 83,
    supplierId: 10,
    supplierName: 'ООО «Пермский Склад»',
  },
  {
    id: 14262,
    name: 'СЫР Моцарелла для пиццы 40% брус',
    price: 621.6,
    unit: 'КГ',
    packageSize: 'Кусок',
    productTypeId: 83,
    supplierId: 12,
    supplierName: 'ООО «Таёжный Ряд»',
  },
  {
    id: 17690,
    name: 'Молоко 3 2% х12шт/кор ГОСТ БЗМЖ Professional line',
    price: 104.92,
    unit: 'л',
    packageSize: '12х1л',
    productTypeId: 74,
    supplierId: 11,
    supplierName: 'ООО «Белая Кухня»',
  },
  {
    id: 17692,
    name: 'Молоко 3 2% tetra-pak х12шт/кор ГОСТ БЗМЖ UHT Эгида Поволжье',
    price: 83.4,
    unit: 'л',
    packageSize: '12х1л',
    productTypeId: 74,
    supplierId: 11,
    supplierName: 'ООО «Белая Кухня»',
  },
  {
    id: 16639,
    name: 'Кофе зерновой Poetti Classico',
    price: 1166.56,
    unit: 'шт',
    packageSize: '1 кг',
    productTypeId: 249,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
  {
    id: 14226,
    name: 'Лайм',
    price: 613.19,
    unit: 'кг',
    packageSize: null,
    productTypeId: 357,
    supplierId: 8,
    supplierName: 'ООО «УралПродукт»',
  },
  {
    id: 15540,
    name: 'Лайм',
    price: 399.93,
    unit: 'кг',
    packageSize: null,
    productTypeId: 357,
    supplierId: 9,
    supplierName: 'ООО «Кама Опт»',
  },
  {
    id: 15338,
    name: 'Мята',
    price: 1483.39,
    unit: 'кг',
    packageSize: null,
    productTypeId: 40,
    supplierId: 8,
    supplierName: 'ООО «УралПродукт»',
  },
  {
    id: 15489,
    name: 'Мята',
    price: 1647.2,
    unit: 'кг',
    packageSize: null,
    productTypeId: 40,
    supplierId: 9,
    supplierName: 'ООО «Кама Опт»',
  },
  {
    id: 16325,
    name: 'Масло подсолнечное',
    price: 772.62,
    unit: 'шт',
    packageSize: '5 л',
    productTypeId: 144,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
  {
    id: 16395,
    name: 'Огурцы маринованные кольца / сухой вес ( х 5 шт)',
    price: 257.98,
    unit: 'кг',
    packageSize: '5 кг пакет',
    productTypeId: 327,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
  {
    id: 17323,
    name: 'Напиток для кофе Кокосовый',
    price: 154.65,
    unit: 'шт',
    packageSize: '1 л',
    productTypeId: 208,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
  {
    id: 17857,
    name: 'Пюре маракуйя без косточек 90% пл/конт',
    price: 761.65,
    unit: 'шт',
    packageSize: '8х1кг',
    productTypeId: 243,
    supplierId: 11,
    supplierName: 'ООО «Белая Кухня»',
  },
  {
    id: 17095,
    name: 'Макаронс Манго-Маракуйя х 64 шт Акульчев',
    price: 27.64,
    unit: 'шт',
    packageSize: '768 г/кор',
    productTypeId: 221,
    supplierId: 13,
    supplierName: 'ООО «Закамье Трейд»',
  },
]

export interface InventoryDemoCatalogOffer {
  id: number
  name: string
  price: number
  unit: string
  packageSize: string | null
  productTypeId: number
  supplierId: number
  supplierName: string
}
